/**
 * SwapGemsBetweenTowers use case: swap gems in slot 0 of two towers.
 */

import { swapGemsBetweenTowers as domainSwapGems } from "../../domain/session.js";
import type { PlaceGemError } from "../../domain/types.js";
import type { RenderPort, AudioPort } from "../ports.js";
import { sessionToView } from "../state-view.js";

export interface SwapGemsBetweenTowersDeps {
  render: RenderPort;
  audio: AudioPort;
  getSession(): import("../../domain/session.js").GameSession | null;
}

export function createSwapGemsBetweenTowers(deps: SwapGemsBetweenTowersDeps) {
  return function swapGemsBetweenTowersUseCase(
    towerId1: string,
    towerId2: string
  ): { ok: true } | PlaceGemError {
    const session = deps.getSession();
    if (!session) return { code: "InvalidSlot" };
    const ok = domainSwapGems(session, towerId1, towerId2);
    if (!ok) return { code: "InvalidSlot" };
    deps.render.update(sessionToView(session, "game"));
    deps.audio.play("click");
    return { ok: true };
  };
}
